import docsService from '@/services/DocsService';
import { Modal, Spinner, SpinnerSize } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
interface DocLinkProps {
    fileName: string,
    docId: number
};

export const DocLink = (props: DocLinkProps) => {
    const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);

    const downloadBase64Attachment = (event: any) => {
        event.preventDefault();
        showModal();
        docsService.docAttachment(props.docId)
            .then((response: any) => {
                const file = new Blob(
                    [response.data],
                    { type: response.headers['content-type'] });
    
                var downloadLink = document.createElement("a");
                downloadLink.download = props.fileName;
                downloadLink.href = URL.createObjectURL(file);
                downloadLink.style.display = "none";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                hideModal();
            })
            .catch((error: any) => {
                console.log(error);
            });
        };

    return (
        <>
            <a href={props.fileName} target="_blank" rel="noreferrer" download={props.fileName} onClick={(event) => downloadBase64Attachment(event)}>
                {props.fileName}
            </a>
            {isModalOpen && (
                <Modal
                    isOpen={isModalOpen}
                    onDismiss={hideModal}
                    isBlocking={false}
                >
                    <h3>Descargando archivo</h3>
                    <Spinner size={SpinnerSize.large} />
                </Modal>
            )}
        </>
    );
};
